import axios from 'axios'
import Cookies from 'js-cookie'

const API_ROOT = 'https://konfigurator.galabbg.pl'
//const API_ROOT = 'http://localhost:8000'
const API_BASE_URL = `${API_ROOT}/api`

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true,
})

const authClient = axios.create({
  baseURL: API_ROOT,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

const attachCsrfToken = (client) => {
  client.interceptors.request.use((config) => {
    const xsrfToken = Cookies.get('XSRF-TOKEN')
    if (xsrfToken) {
      config.headers['X-XSRF-TOKEN'] = xsrfToken
    }
    return config
  })
}

attachCsrfToken(apiClient)
attachCsrfToken(authClient)

apiClient.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 419 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await authClient.get('/sanctum/csrf-cookie')

        return apiClient(originalRequest)
      } catch (csrfError) {
        return Promise.reject(csrfError)
      }
    }

    return Promise.reject(error)
  }
)

export { API_ROOT, apiClient, authClient }

export default {
  get(endpoint, params = {}) {
    return apiClient.get(endpoint, { params })
  },
  post(endpoint, data) {
    return apiClient.post(endpoint, data)
  },
  put(endpoint, data) {
    return apiClient.put(endpoint, data)
  },
  delete(endpoint) {
    return apiClient.delete(endpoint)
  },
  auth: {
    csrf() {
      return authClient.get('/sanctum/csrf-cookie')
    },
    login(data) {
      return authClient.post('/login', data)
    },
    logout() {
      return authClient.post('/logout')
    },
    fetchUser() {
      return authClient.get('/api/user')
    },
    forgotPassword(data) {
      return authClient.post('/api/forgot-password', data)
    },
    resetPassword(data) {
      return authClient.post('/api/reset-password', data)
    },
    updatePassword(data) {
      return apiClient.put('/user/password', data)
    },
  },
}